import Api from '../../services';

// ACTION TYPES
export const usersHasErrored = () => ({ type: '[USERS] HAS_ERRORED' });
export const usersIsLoading = () => ({ type: '[USERS] IS_LOADING' });
export const usersIsSubmiting = user => ({
  type: '[USERS] IS_SUBMITING',
  user,
});
export const usersFetchSuccess = data => ({
  type: '[USERS] FETCH_SUCCESS',
  data,
});
// ACTION CREATORS
export const dash_action_logged = (params = {}) => async dispatch => {
  dispatch(usersIsLoading());
 await Api.Admin.getDashs(params)
    .then(data => dispatch(usersFetchSuccess(data)))
    .catch(() => dispatch(usersHasErrored()));
};

export const get_user_details_logged = (params = {}) => async dispatch => {
  dispatch(usersIsLoading());
  await Api.Admin.getUserDetails(params)
      .then(data => dispatch(usersFetchSuccess(data)))
      .catch(() => dispatch(usersHasErrored()));
};
